import React, { useState, useEffect } from "react";
import web3 from "../../Service/web3";
import SpinWheelCard from "../../Pages/User/spinner-lottery/components/SpinWheelCard";

const SpinWheel = ({ lotteryData, partner, partnerLogo }) => {
  const [account, setAccount] = useState("");

  useEffect(() => {
    if (window.ethereum) {
      window.web3 = web3;
      web3.eth.getAccounts().then((accounts) => {
        if (accounts && accounts.length > 0) {
          setAccount(accounts[0]);
        }
      });

      const handleAccounts = (accs) => {
        if (accs.length > 0) setAccount(accs[0]);
        else setAccount("");
      };
      window.ethereum.on("accountsChanged", handleAccounts);
      return () => {
        if (window.ethereum.removeListener) {
          window.ethereum.removeListener("accountsChanged", handleAccounts);
        }
      };
    }
  }, []);

  const handleConnectWallet = async () => {
    if (window.ethereum) {
      try {
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        if (accounts && accounts.length > 0) {
          setAccount(accounts[0]);
        }
      } catch (err) {
        console.error("Connect wallet error:", err);
      }
    }
  };

  return (
    <SpinWheelCard
      lotteryData={lotteryData}
      partner={partner}
      partnerLogo={partnerLogo}
      account={account}
      onConnectWallet={handleConnectWallet}
    />
  );
};

export default SpinWheel;
